import { dynamicLengthValidator } from "../../../common/Utils/Utils";
import {
  emailValidator,
  passwordValidator,
} from "../../../common/Validators/Validators";

export const LoginFormField = () => [
  {
    label: "Email",
    field: "email",
    span: 24,
    type: "text",
    maxLength: 254,
    placeholder: "Enter your email",
    required: true,
    rules: [
      { required: true, message: "Email is required" },
      {
        validator: dynamicLengthValidator(6, "Email"),
      },
      emailValidator("Please enter a valid email"),
    ],
  },
  {
    field: "password",
    label: "Password",
    span: 24,
    type: "password",
    maxLength: 15,
    required: true,
    placeholder: "Enter your password",
    rules: [{ validator: passwordValidator }],
  },
  // {
  //   field: 'rememberMe',
  //   label: '',
  //   span: 12,
  //   type: 'checkbox',
  //   required: true,
  //   checkboxLabel: 'Remember Me',
  // },
];
